package kmp.multimodule.sample.common.core

actual class PlatformConfiguration